import type { FaireProductEntity } from "../../entity_types/product";

export const p_59ezzbf9: FaireProductEntity = {
  token: "p_59ezzbf9",
  type: "product",
  name: "Flying Cake Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8944a0ee365a4b6fc6973bf74dc80380e20fcad49fde2dbc9c3112cc37bef738/1528333853.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6405a9bec734cc0d0dd9a2867ceaf27c38addac787ab3a7a99b410f3a7cc4fb8/1528333853.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:05.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
